import { useQuery } from 'react-query';

import { getUsersList as queryFn } from 'api/endPoints/getUsersList';

export const useQueryUsersList = () => {
    return useQuery('usersList', () => queryFn());
};
